import type React from 'react';
import type { AutocompleteUser } from '../../models';
import { Avatar } from '../avatar';
import { Text } from '../typography';

type P = {
  cardAction?: React.ReactNode;
  user: AutocompleteUser;
};

const ProfileCard: React.FC<P> = ({ cardAction, user }) => (
  <div className="profile-card">
    <div className="profile-card__avatar">
      <Avatar photo={user.profilePhoto?.url} size={48} />
    </div>
    <div className="profile-card__name">
      <Text type="primary">
        {user.firstName} {user.lastName}
      </Text>
    </div>
    <div className="profile-card__action">{cardAction}</div>
  </div>
);

export default ProfileCard;
